export const ShieldIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width ?? '12'}
    height={props.height ?? '13'}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.96941 11.554C5.91138 11.554 5.85749 11.5499 5.80774 11.5416C5.758 11.5333 5.70825 11.5208 5.65851 11.5043C4.53925 11.1312 3.64799 10.441 2.98473 9.43389C2.32147 8.42672 1.98984 7.34262 1.98984 6.18158V3.83114C1.98984 3.62387 2.05003 3.43733 2.17041 3.27152C2.29079 3.1057 2.44616 2.98548 2.63652 2.91087L5.6212 1.79161C5.73727 1.75016 5.85334 1.72943 5.96941 1.72943C6.08548 1.72943 6.20155 1.75016 6.31762 1.79161L9.3023 2.91087C9.49299 2.98548 9.64853 3.1057 9.76891 3.27152C9.88929 3.43733 9.94932 3.62387 9.94898 3.83114V6.18158C9.94898 7.34229 9.61735 8.42639 8.95409 9.43389C8.29083 10.4414 7.39957 11.1315 6.28032 11.5043C6.23057 11.5208 6.18083 11.5333 6.13108 11.5416C6.08134 11.5499 6.02745 11.554 5.96941 11.554ZM5.96941 10.5591C6.83165 10.2855 7.54466 9.73832 8.10843 8.91754C8.6722 8.09675 8.95409 7.18476 8.95409 6.18158V3.83114L5.96941 2.71189L2.98473 3.83114V6.18158C2.98473 7.18476 3.26662 8.09675 3.83039 8.91754C4.39416 9.73832 5.10717 10.2855 5.96941 10.5591Z"
      fill={props.color ?? '#8B929E'}
    />
  </svg>
);
